export type RoleListTab = 'roles' | 'bundles';

interface RoleListTabsProps {
    activeTab: RoleListTab;
    onChange: (tab: RoleListTab) => void;
    roleCount: number;
    bundleCount: number;
}

const TABS: readonly { readonly id: RoleListTab; readonly label: string }[] = [
    { id: 'roles', label: 'Roles' },
    { id: 'bundles', label: 'Bundles' }
];

// Modelled on PracticeDetailHeader's TabBar. A role is grantable, a bundle
// never is; switching tabs always selects that tab's first entry.
export function RoleListTabs({ activeTab, onChange, roleCount, bundleCount }: RoleListTabsProps) {
    const counts: Record<RoleListTab, number> = { roles: roleCount, bundles: bundleCount };
    return (
        <div className="shrink-0 px-3 flex gap-4 border-b border-gray-100">
            {TABS.map((tab) => {
                const isActive = tab.id === activeTab;
                return (
                    <button
                        key={tab.id}
                        type="button"
                        onClick={() => onChange(tab.id)}
                        aria-pressed={isActive}
                        className={`pt-2.5 pb-2 text-[12px] flex items-center gap-1.5 border-b-2 transition-colors ${
                            isActive
                                ? 'font-semibold text-gray-900 border-gray-900'
                                : 'font-medium text-gray-500 border-transparent hover:text-gray-700'
                        }`}
                    >
                        {tab.label}
                        <span className={isActive ? 'text-gray-400' : 'text-gray-300'}>
                            {counts[tab.id]}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
